const wheelSensitiveInputSelector = [
  'input[type="number"]',
  'input[type="date"]',
  'input[type="datetime-local"]',
  'input[type="month"]',
  'input[type="range"]',
  'input[type="time"]',
  'input[type="week"]',
  'input[role="spinbutton"]',
].join(',');

export const preventInputScrollChanges = (event) => {
  const activeElement = event.currentTarget?.activeElement;
  const wheelTarget = event.target;

  if (activeElement?.matches?.(wheelSensitiveInputSelector)) {
    activeElement.blur();
  }

  if (wheelTarget?.matches?.(wheelSensitiveInputSelector)) {
    // Ant Design handles wheel events directly on InputNumber. Stop that
    // handler without preventing the browser from scrolling the page.
    event.stopPropagation();
  }
};

export const installInputScrollGuard = (document) => {
  document.addEventListener('wheel', preventInputScrollChanges, {
    capture: true,
    passive: true,
  });

  return () => document.removeEventListener('wheel', preventInputScrollChanges, true);
};
